export const getTabIdByUrlPath = url => {
    const path = url ?? window.location.pathname;
    const splitPathBySlash = path.split("/");
    return splitPathBySlash[splitPathBySlash.length - 1];
};
